import { render, staticRenderFns } from "./MyMenu.vue?vue&type=template&id=176ed4fd&scoped=true"
import script from "./MyMenu.vue?vue&type=script&lang=js"
export * from "./MyMenu.vue?vue&type=script&lang=js"
import style0 from "./MyMenu.vue?vue&type=style&index=0&id=176ed4fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176ed4fd",
  null
  
)

export default component.exports